import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import CryptoJS from 'crypto-js';

import GenericBanner from '../assets/images/Products.png';
import A_Accessories from '../assets/images/category-banners/A_Accessories.jpg';
import B_Adhesives_Screeds from '../assets/images/category-banners/B_Adhesives_Screeds.jpg';
import C_Carpet from '../assets/images/category-banners/C_Carpet.jpg';
import E_Contract from '../assets/images/category-banners/E_Contract.jpg';
import G_Grass from '../assets/images/category-banners/G_Grass.jpg';
import H_Underlay from '../assets/images/category-banners/H_Underlay.jpg';
import L_LVT from '../assets/images/category-banners/L_LVT.jpg';
import N_Laminate from '../assets/images/category-banners/N_Laminate.jpg';
import O_Mats_Runners from '../assets/images/category-banners/Cat_O_Banner_Mats_and_Runners_V2.jpeg';
import Q_Matting from '../assets/images/category-banners/Q_Matting.jpg';
import R_Rugs from '../assets/images/category-banners/R_Rugs.jpg';
import T_CarpetTile from '../assets/images/category-banners/T_CarpetTile.jpg';
import V_Banner_Vinyl from '../assets/images/category-banners/V_Banner_Vinyl.jpg';
import A_Accessories_Image from '../assets/images/categories/Cat_A_Accessories_V2.jpeg';
import B_Adhesives_Screeds_Image from '../assets/images/categories/B_Adhesive_Screeds.jpg';
import C_Carpet_Image from '../assets/images/categories/C_Carpet.jpg';
import E_Contract_Image from '../assets/images/categories/E_Contract.jpg';
import G_Grass_Image from '../assets/images/categories/G_Grass.jpeg';
import H_Underlay_Image from '../assets/images/categories/H_Underlay.jpg';
import L_LVT_Image from '../assets/images/categories/L_LVT.jpg';
import N_Laminate_Image from '../assets/images/categories/N_Laminate.jpg';
import O_Mats_Runners_Image from '../assets/images/categories/Cat_O_Mats_and_Runners_V2.jpeg';
import Q_Matting_Image from '../assets/images/categories/Q_Matting.jpg';
import R_Rugs_Image from '../assets/images/categories/Cat_R_Rugs_V2.jpeg';
import T_CarpetTile_Image from '../assets/images/categories/T_Carpet_Tiles.jpg';
import V_Banner_Vinyl_Image from '../assets/images/categories/V_Vinyl.jpg';

export const roundNumber = (num: number) => _.round(num, 2).toFixed(2);

export const getCategoryImage = (category: string) => {
  switch (category) {
    case 'A':
      return A_Accessories_Image;
    case 'B':
      return B_Adhesives_Screeds_Image;
    case 'C':
      return C_Carpet_Image;
    case 'E':
      return E_Contract_Image;
    case 'G':
      return G_Grass_Image;
    case 'H':
      return H_Underlay_Image;
    case 'L':
      return L_LVT_Image;
    case 'N':
      return N_Laminate_Image;
    case 'O':
      return O_Mats_Runners_Image;
    case 'Q':
      return Q_Matting_Image;
    case 'R':
      return R_Rugs_Image;
    case 'T':
      return T_CarpetTile_Image;
    case 'V':
      return V_Banner_Vinyl_Image;
    default:
      return GenericBanner;
  }
};

export const getCategoryBannerImage = (category?: string) => {
  switch (category) {
    case 'A':
      return A_Accessories;
    case 'B':
      return B_Adhesives_Screeds;
    case 'C':
      return C_Carpet;
    case 'E':
      return E_Contract;
    case 'G':
      return G_Grass;
    case 'H':
      return H_Underlay;
    case 'L':
      return L_LVT;
    case 'N':
      return N_Laminate;
    case 'O':
      return O_Mats_Runners;
    case 'Q':
      return Q_Matting;
    case 'R':
      return R_Rugs;
    case 'T':
      return T_CarpetTile;
    case 'V':
      return V_Banner_Vinyl;
    default:
      return GenericBanner;
  }
};

const lPrefix = 'LKWS_';
const hash = 'D8bsf7HmHJHm0srBm9Bcy6iC';
const lKeys = {
  CUSTOMER_ID: 'CUSTOMER_ID',
  CUSTOMER_POSTCODE: 'CUSTOMER_POSTCODE',
  AUTH_COOKIE_LAST_REQUESTED: 'AUTH_COOKIE_LAST_REQUESTED',
};

export const lwRoundNumber = (input: any) => {
  const num = parseFloat(parseFloat(input).toFixed(2));
  const decimals = parseInt(((num % 1) * 100).toFixed(0));
  const numberX = Math.trunc(num);
  const roundToFive = Math.ceil(decimals / 5) * 5;
  const result = numberX + (roundToFive / 100);
  return result >= 0.5 ? result : 0;
};

export const objectToQueryString = (obj: any) => _.reduce(obj, (result, value, key) => {
  return (!_.isNull(value) && !_.isUndefined(value)) ? (result += key + '=' + value + '&') : result;
}, '').slice(0, -1);

export const digestMessage = async (message: string) => { // ex: 'WF10 5NU01/09/21'
  const msgUint8 = new TextEncoder().encode(message);                           // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string ;
};

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const localStorageSetItem = (key: string, value: string) => {
  window.localStorage.setItem(`${lPrefix}${key}`, value);
};

const localStorageGetItem = (key: string) => {
  return window.localStorage.getItem(`${lPrefix}${key}`);
};

export const getCustomerID = () => {
  return localStorageGetItem(lKeys.CUSTOMER_ID);
};

export const setCustomerID = (customerId: string) => {
  localStorageSetItem(lKeys.CUSTOMER_ID, customerId);
};

export const getCustomerPostcode = () => {
  const val = localStorageGetItem(lKeys.CUSTOMER_POSTCODE);
  // @ts-ignore
  return val ? CryptoJS.AES.decrypt(val, hash).toString(CryptoJS.enc.Utf8) : val;
};

export const setCustomerPostcode =  (postcode: string) => {
  const val = CryptoJS.AES.encrypt(postcode, hash);
  localStorageSetItem(lKeys.CUSTOMER_POSTCODE, val.toString());
};

export const isAuthenticated = () => !(!getCustomerPostcode() || !getCustomerID());
